<template>
  <div class="hello">
    <landing v-if="!currentUser"/>
    <allbeers v-if="currentUser&&userProfile.isbrewer<=0"/>
    <brewerdashboard v-if="currentUser&&(userProfile.isbrewer==1||userProfile.isbrewer==2||userProfile.isbrewer==10)"/>
  </div>
</template>

<script>
import Login from './Login'
import Landing from './Landing'
import Dashboard from '@/components/Dashboard'
import Allbeers from '@/components/Allbeers'
import Brewerdashboard from '@/components/Brewerdashboard'
import { mapState } from 'vuex'

export default {    
  name: 'Firstpage',
  props: {
    msg: String
  },

    computed: {
        ...mapState(['isBrewer', 'userProfileStatus', 'userProfile', 'allBrewersList', 'currentUser'])
    },

    components: {
        Login,
        Dashboard,
        Brewerdashboard,
        Allbeers,
        Landing,
    },
    mounted(){
        this.$store.dispatch('setAppOptions');
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
